import { Alert } from '@creditornot/cb-alert';
import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { ModalFooter, ModalHeader, ModalContent } from '@creditornot/cb-modal';
import React from 'react';
import { Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { VenueGroup } from 'apis/venue-groups/types';
import { WoltModal } from 'common/components';

type Props = {
  venueGroup?: VenueGroup;
  isOpen: boolean;
  onSubmit: (venueGroupId: string) => void;
  onClose: () => void;
};

const Root = styled(WoltModal)`
  width: 700px;
  background: ${cbSemanticCssVars.surfaceMain};
  border-radius: 8px;
`;

const Buttons = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

const StyledFooter = styled(ModalFooter)`
  display: flex;
  flex-direction: column;
`;

const SubmitError = styled(Alert).attrs({ variant: 'error' })`
  width: 100%;
  margin: 0 0 16px;
`;

export const DeleteVenueGroupModal = ({ venueGroup, onSubmit, isOpen, onClose }: Props) => {
  return (
    <Root isOpen={isOpen} onRequestClose={onClose}>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting, submitError }) => {
          return (
            <form onSubmit={handleSubmit}>
              <ModalHeader onCloseClick={onClose}>
                <FormattedMessage id={'venue-groups.form.delete-venue-group'} />
              </ModalHeader>

              <ModalContent>
                {submitError && <SubmitError>{submitError}</SubmitError>}

                <FormattedMessage
                  id="venue-groups.form.delete-venue-group-warning-message"
                  values={{ name: venueGroup?.name ?? '' }}
                />
              </ModalContent>

              <StyledFooter>
                <Buttons>
                  <Button onClick={onClose} variant="lightBlue" size="small">
                    <FormattedMessage id="state.cancel" />
                  </Button>

                  <Button loading={submitting} type="submit" variant="lightRed" size="small" disabled={submitting}>
                    <FormattedMessage id="state.delete" />
                  </Button>
                </Buttons>
              </StyledFooter>
            </form>
          );
        }}
      />
    </Root>
  );
};
